import React, {Component} from 'react'
import {Button, Row, Col, Tabs, message, Popconfirm} from 'antd';
import {Redirect, Switch, Route, withRouter} from 'react-router-dom'
import './index.less'
import OrderTrack from "./order-track";
import OrderFile from "./order-file";
import {getOrder, getOrderDelivery, reqReview, reqBoxComplete} from '../../api'
import authorizePage from "../../components/authorize/authorizePage";
import authorizeBase from "../../components/authorize/authorizeBase";
import OrderBoxFile from "./order-box-file";
import OrderDeclare from './order-declare';
const AuthButton = authorizeBase(Button)
const {TabPane} = Tabs;

let orderId = '';
class OrderInfo extends Component {
    constructor(props) {
        super(props)
        this.state = {
            order: {
                entrustingNo: '',
                containerNum: '',
                createdDt: '',
                status: '',
                transferStatus: '',
                packageManageVoList: [],
                goodsName: '',
                pcsNumber: ''
            },
            boxNo: '',
            carNo: '',
        }
    }

    componentWillMount() {
        sessionStorage.removeItem("track");
        sessionStorage.removeItem("space");
        sessionStorage.removeItem("invoice");
    }

    componentDidMount() {
        if (this.props.location.state) {
            orderId = this.props.location.state.orderId;
            this.getOrderShortFunc(orderId);
            this.getOrderDeliveryFunc(orderId);
        }
    }

    judgeReadOnly = orderStatus => {
        if (orderStatus == 'audit' || orderStatus == 'audited') {
            return true;
        }
        return false;
    };
    callback = (key) => {
        this.props.history.push(key, {orderId: orderId})
    }
    getOrderShortFunc = async (id) => {
        let result = await getOrder(id)
        if (result.code === 200) {
            var data = result.data;
            var status = {
                'new': '新建',
                'failed': '已驳回',
                audit: '待审核',
                audited: '待订舱',
                booked: '已订舱',
                boxed: '已装箱',
                declare: '待报关',
                declaring: '报关中',
                released: '已放行'
            };
            var transferStatus = {
                waiting: '待揽货',
                transport: '运输中',
                declaring: '报关中',
                released: '已放行'
            };
            data.status = status[data.orderStatus];
            data.transferStatus = transferStatus[data.logisticsStatus]
            let goodsName = '';
            //let pcsNumber = 0;
            let packageManageVoList = data.packageManageVoList
            if (packageManageVoList && packageManageVoList.length > 0) {
                for (let j = 0; j < packageManageVoList.length; j++) {
                    if (packageManageVoList[j].name && j <= 1) {
                        goodsName = goodsName + packageManageVoList[j].name + '，';
                    }
                    if (packageManageVoList[j].name && j === 2) {
                        goodsName = goodsName + '...' + ' ';
                    }
                    // pcsNumber += packageManageVoList[j].num
                }
                goodsName = goodsName.substr(0, goodsName.length - 1)
            }
            this.setState({
                order: data,
                goodsName,
                readOnly: this.judgeReadOnly(data.orderStatus)
            })

        } else {
            message.error(result.message)
        }
    }

    getOrderDeliveryFunc = async (id) => {
        let result = await getOrderDelivery(id)
        if (result.code === 200) {
            var data = result.data;

            if (data && data.length > 0) {
                let boxNo = '';
                let carNo = '';
                for (let i = 0; i < data.length; i++) {
                    if (data[i].boxNo) {
                        boxNo = boxNo + data[i].boxNo + ' ';
                    }
                    if (data[i].carNo) {
                        carNo = carNo + data[i].carNo + ' ';
                    }
                }

                this.setState({
                    boxNo: boxNo,
                    carNo: carNo
                })
            }

        } else {
            message.error(result.message)
        }
    }

    approveOrder = async () => {
        orderId = this.props.location.state.orderId;
        const type = 1
        let result = await reqReview(orderId, type)
        if (result.code === 200) {
            this.props.history.replace('/trackList')
        } else if (result.code === 204) {
            message.error(result.message)
        } else {
            message.error(result.message)
        }
    }

    rejectOrder = async () => {
        orderId = this.props.location.state.orderId;
        const type = 0
        let result = await reqReview(orderId, type)
        if (result.code === 200) {
            this.props.history.replace('/orderList')
        } else if (result.code === 204) {
            message.error(result.message)
        } else {
            message.error(result.message)
        }
    }

    handleComplete = async () => {
        let result = await reqBoxComplete(orderId)
        if (result.code === 200) {
            this.props.history.replace('/orderList')
        } else if (result.code === 204) {
            message.error(result.message)
        } else {
            message.error(result.message)
        }
    }

    render() {

        const path = this.props.location.pathname
        return (
            <div className='order-info box-shadow padding-20'>
                <div className="head-title">
                    <div className='flex-between'>
                        <span className='title' style={{lineHeight: '32px'}}>订单详情</span>
                        {/*<span className='opt'>
                         <Popconfirm title="是否确定不通过?" onConfirm={() => this.rejectOrder()}>
                         <Button style={{marginRight: '10px'}} type='default' className='failedButton'>审核不通过</Button>
                         </Popconfirm>

                         <Popconfirm title="是否确定审核通过?" onConfirm={() => this.approveOrder()}>
                         <Button type='primary'>审核通过</Button>
                         </Popconfirm>
                         </span>*/}
                        {this.state.order.orderStatus != 'failed' && this.state.order.orderStatus != 'new' ?
                            <AuthButton authority="order_edit:complete_box" type='primary' style={{float: 'right'}}
                                        onClick={this.handleComplete}>完成装箱</AuthButton> : ''}
                    </div>
                </div>
                <div className="order-info-details">
                    <Row className='order-info-item'>
                        <Col span={6}>
                            <span className='label'>订单编号 : </span>
                            <span>{this.state.order.orderNo}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>企业名称: </span>
                            <span>{this.state.order.entName}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>起运地: </span>
                            <span>{this.state.order.originCountry} {this.state.order.originCity}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>转关地: </span>
                            <span>{this.state.order.destinationStartCountry} {this.state.order.destinationStartCity}</span>
                        </Col>

                    </Row>
                    <Row className='order-info-item'>
                        <Col span={6}>
                            <span className='label'>目的地 : </span>
                            <span>{this.state.order.destinationCountry} {this.state.order.destinationCity}</span>
                        </Col><Col span={6}>
                        <span className='label'>还箱地: </span>
                        <span>{this.state.order.boxReturnStation}</span>
                    </Col>

                        <Col span={6}>
                            <span className='label'>提交时间 : </span>
                            <span>{this.state.order.commitDt}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>发货时间 : </span>
                            <span>{this.state.order.deliveryEstimateDt}</span>
                        </Col>
                    </Row>
                </div>
                <div className='order-info-tab'>
                    <Tabs type="card" tabBarGutter={'16'} onChange={this.callback}
                          defaultActiveKey={path}>
                        <TabPane tab="委托单" key="/trackEdit/track"></TabPane>
                        <TabPane tab="附件" key="/trackEdit/file"></TabPane>
                        <TabPane tab="提箱单" key="/trackEdit/box-file"></TabPane>
                        {/*<TabPane tab="报关单" key="/trackEdit/declare"></TabPane>*/}
                    </Tabs>
                </div>
                <div className='order-info-content'>
                    <Switch>
                        <Route path='/trackEdit/track' component={OrderTrack}/>
                        <Route path='/trackEdit/file' component={OrderFile}/>
                        <Route path='/trackEdit/box-file'
                               render={(props) => <OrderBoxFile {...props} readonly={true}/>}/>
                        <Route path='/trackEdit/declare' component={OrderDeclare}/>
                        <Route component={OrderTrack}/>
                    </Switch>
                </div>

            </div>
        )

    }
}
export default authorizePage("order:edit")(withRouter(OrderInfo))